import { render, staticRenderFns } from "./SettingsMnemonicShow.vue?vue&type=template&id=31fc9cf3&scoped=true"
import script from "./SettingsMnemonicShow.vue?vue&type=script&lang=js"
export * from "./SettingsMnemonicShow.vue?vue&type=script&lang=js"
import style0 from "./SettingsMnemonicShow.vue?vue&type=style&index=0&id=31fc9cf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fc9cf3",
  null
  
)

export default component.exports